import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, map, pluck, timeout } from 'rxjs/operators';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { CookieHandler } from '../classes/cookie.class';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from "ngx-toastr";


@Injectable()
export class HttpsInterceptor implements HttpInterceptor {

    constructor(
        private readonly _snackbar: MatSnackBar,
        private readonly _router: Router,
           private toaster:ToastrService

    ) { }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (!window.navigator.onLine) {

            this.toaster.error('متاسفیم به نظر میرسد اتصال اینترنت شما برقرار نمی باشد!')

            return EMPTY;
        }
        let token = CookieHandler.getToken();
        if (token == null || token == undefined) token = '';
        let tokenizedRequest: HttpRequest<any> = request;
        tokenizedRequest = request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });
        return next.handle(tokenizedRequest).pipe(
            // timeout(30000),
            // map((res: any) => res.response),
            catchError((error: HttpErrorResponse) => this.errorHandler(error))
        );
    }

    errorHandler(error: HttpErrorResponse) {
        switch (error.status) {
            case 404:
                this.toaster.error('متاسفیم نمیتونیم سرویس رو پیدا کنیم!')

                return throwError(() => error);
            case 401:
                this.toaster.error('مجوز دسترسی شما منقضی شده است')

                  this._router.navigate(['/login']);
                return throwError(() => error);
            case 403:
                this.toaster.error('شما دسترسی کافی ندارید!')

                  this._router.navigate(['/login']);

                return throwError(() => error);
            case 500:
                this.toaster.error('عملیات با شکست مواجه شد!')
                return throwError(() => error);

                case 400:
                    this.toaster.error(' لطفا در درخواست ورودی دقت فرمایید !')
                return throwError(() => error);
            default:
                return throwError(() => error);
        }
    }


}
